export default "__VITE_ASSET__7c7bba5b__"